<template>
  <div>
    <div v-show="permissao != null">
      <b-row class="mt-4">
        <b-col cols="12">
          <div class="titlePage mb-3">Configuração Definida para Publicação</div>
        </b-col>

        <b-col cols="12">
          <fcc-button
            icon="trash-alt"
            @click="deletaConfiguracao"
            class="mb-2"
            :disabled="lstConfigFinal.length > 0"
          >
            Deletar
          </fcc-button>
        </b-col>
        <b-col cols="12">
          <fcc-table
            striped
            hover
            :actions="actionsSolicitante"
            :fields="fieldsSolicitante"
            :items="lstSolicitante"
            responsive
            :mostrarQuantidade="false"
          />
        </b-col>
        <b-col cols="12" class="mt-4">
          <div class="titlePage mb-3">Seleção dos Cargos e Provas Objetivas</div>
        </b-col>
        <b-col cols="12">
          <fcc-button
            class="mb-2"
            icon="plus"
            @click="adicionaCargoProva"
            :disabled="cargosSelecionados.length == 0"
          >
            Adicionar
          </fcc-button>
        </b-col>
        <b-col cols="12">
          <fcc-table
            striped
            hover
            :fields="fieldsCargosProvas"
            :items="lstCargosProvas"
            responsive
            @row-selected="atualizaSelecionado"
            :mostrarQuantidade="false"
            :por-page="'100'"
            pagination
          />
        </b-col>
      </b-row>
      <fcc-cargos-provas-definidos
        v-if="lstConfigFinal.length > 0"
        :lstConfigFinal="lstConfigFinal"
        :idNotificacao="idNotificacao"
        :temExportacao="temExportacao"
        :lstExportacao="lstExportacao"
        @listarExportacao="listarExportacao"
        @listarConfiguracaoFinal="listarConfiguracaoFinal"
      />
      <fcc-exportacao
        v-if="lstExportacao.length > 0 && lstExportacao[0].dataexportacao"
        :idNotificacao="idNotificacao"
        :lstExportacao="lstExportacao"
        :desabilitaDeletar="desabilitaBotao"
        @listarExportacao="listarExportacao"
      />
      <fcc-upload-provas
        v-if="lstSolicitante[0].prova == 'SIM' && temExportacao"
        :idNotificacao="idNotificacao"
        @provasPendentes="salvaProvasPendentes"
        @totalProvas="salvaTotalProvas"
        :liberarExportacao="liberarExportacao"
      />
    </div>
    <fcc-teste-gabarito
      v-if="exibirTesteGabarito"
      :idNotificacao="idNotificacao"
      :prova="lstSolicitante[0].prova"
      :gabarito="lstSolicitante[0].gabarito"
      @listarLiberacao="listarLiberacao"
      :liberarExportacao="liberarExportacao"
    />
    <fcc-liberacao
      v-if="
        temExportacao && lstLiberacao.length > 0 && lstLiberacao[0].dataupload && permissao != null
      "
      :idNotificacao="idNotificacao"
      :lstLiberacao="lstLiberacao"
      :liberarExportacao="liberarExportacao"
      :baseUrlPublicacao="baseUrlPublicacao"
    />
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import fccCargosProvasDefinidos from './fccCargosProvasDefinidos.vue'
import fccExportacao from './fccExportacao.vue'
import fccUploadProvas from './fccUploadProvas.vue'
import fccTesteGabarito from './fccTesteGabarito.vue'
import fccLiberacao from './fccLiberacao.vue'

export default {
  data() {
    return {
      cargosSelecionados: [],

      lstCargosProvas: [],
      lstConfigFinal: [],
      lstExportacao: [],
      permissao: null,
      lstLiberacao: [],
      fieldsSolicitante: [
        { key: 'gabarito', label: 'Gabarito', sortable: true, tdClass: 'text-center' },
        {
          key: 'datainicialdeacessoaogabarito',
          label: 'Data Inicial de Acesso ao Gabarito',
          sortable: true
        },
        { key: 'prova', label: 'Prova', sortable: true, tdClass: 'text-center' },
        {
          key: 'downloadprova',
          label: 'Permitir Download',
          sortable: true,
          tdClass: 'text-center'
        },
        { key: 'datafinaldeacessoaprova', label: 'Data Final de Acesso a Prova', sortable: true },
        { key: 'codigodaopcao', label: 'Código da Opção', sortable: true, tdClass: 'text-center' },
        { key: 'titulo', label: 'Título', sortable: true },
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dataconfiguracao', label: 'Data Configuração', sortable: true },
        { key: 'actions', label: '' }
      ],
      actionsSolicitante: [
        {
          button: true,
          funcaoButton: this.editarSolicitante,
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.executar
        }
      ],
      qtdProvasPendentes: 0,
      qtdTotalProvas: 0,
      fieldsCargosProvas: [
        {
          key: 'rowSelect',
          sortable: false,
          type: 'rowSelect'
        },
        { key: 'idfolha', label: 'Folha', sortable: true },
        { key: 'codcargo', label: 'Cod_Opcao', sortable: true },
        { key: 'cargo', label: 'Opção', sortable: true },
        { key: 'provas', label: 'Provas', sortable: true, type: 'input' }
      ],
      lstInclusao: [],
      lstAlteracao: []
    }
  },
  components: {
    fccCargosProvasDefinidos,
    fccExportacao,
    fccUploadProvas,
    fccTesteGabarito,
    fccLiberacao
  },
  props: {
    idNotificacao: String,
    lstSolicitante: Array
  },
  computed: {
    liberarExportacao() {
      return this.lstLiberacao.length > 0 && this.lstLiberacao[0].dataupload != null
    },
    temExportacao() {
      return this.lstExportacao.length > 0 && this.lstExportacao[0].dataexportacao != null
    },
    exibirTesteGabarito() {
      if (this.lstSolicitante[0].prova === 'SIM') {
        return this.temExportacao && this.qtdProvasPendentes == 0
      }
      return this.temExportacao
    },
    desabilitaBotao() {
      if (this.lstExportacao.length > 0) {
        if (this.lstSolicitante[0].prova === 'SIM') {
          return this.qtdProvasPendentes != this.qtdTotalProvas
        } else {
          return this.liberarExportacao
        }
      }
      return false
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarCargosProvas()
    this.listarConfiguracaoFinal()
    this.listarExportacao()
    this.listarLiberacao()
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
  },
  methods: {
    editarSolicitante(_, item) {
      this.$emit('editarSolicitante', item)
    },
    salvaProvasPendentes(valor) {
      this.qtdProvasPendentes = valor
    },
    salvaTotalProvas(valor) {
      this.qtdTotalProvas = valor
    },
    listarLiberacao() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + `PublicacaoGabarito/ConsultaLiberacao/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstLiberacao = response.data ? [response.data] : []
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deletaExportacao() {
      this.callConfirm(`Tem certeza que deseja deletar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C02'))
        axios
          .delete(
            this.baseUrlPublicacao + `PublicacaoGabarito/DeletarExportacao/${this.idNotificacao}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarExportacao()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch(this.setErrorSystem)
      })
    },
    adicionaCargoProva() {
      this.callConfirm(`Tem certeza que deseja adicionar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlPublicacao + 'PublicacaoGabarito/AdicionarCargoProva',
            this.cargosSelecionados,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarConfiguracaoFinal()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.adicionado)
            this.cargosSelecionados = []
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      })
    },
    deletaConfiguracao() {
      this.callConfirm(`Tem certeza que deseja deletar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C02'))
        axios
          .delete(
            this.baseUrlPublicacao +
              `PublicacaoGabarito/DeleteConfiguracaoProvaGabarito/${this.idNotificacao}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.$emit('listarSolicitante')
            this.carregaTexto()
          })
          .catch(this.setErrorSystem)
      })
    },
    atualizaSelecionado(items) {
      this.cargosSelecionados = items
    },
    listarCargosProvas() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/ListarGabaritoCargosProvas/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCargosProvas = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarConfiguracaoFinal() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/ListarConfiguracaoFinal/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstConfigFinal = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarExportacao() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/SolicitanteDaExportacao/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstExportacao = response.data ? [response.data] : []
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>
